export const REST_API_END_POINT = "http://localhost:4000/webservice/";
export const REST_API = "http://localhost:4000/";